var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQcTraywhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 2.08333H7.54687C6.33958 2.08333 5.73646 2.08333 5.24896 2.25312C4.78951 2.41637 4.3738 2.68319 4.03403 3.0329C3.69426 3.3826 3.43953 3.80583 3.28958 4.26979C3.125 4.77187 3.125 5.3927 3.125 6.63541V21.2229C3.125 22.1167 4.15104 22.5917 4.8 21.9979C4.98207 21.8297 5.22086 21.7362 5.46875 21.7362C5.71664 21.7362 5.95543 21.8297 6.1375 21.9979L6.64062 22.4583C6.95959 22.7533 7.37806 22.9171 7.8125 22.9171C8.24694 22.9171 8.66541 22.7533 8.98437 22.4583C9.30334 22.1634 9.72181 21.9995 10.1562 21.9995C10.5907 21.9995 11.0092 22.1634 11.3281 22.4583C11.6471 22.7533 12.0656 22.9171 12.5 22.9171C12.9344 22.9171 13.3529 22.7533 13.6719 22.4583C13.9908 22.1634 14.4093 21.9995 14.8437 21.9995C15.2782 21.9995 15.6967 22.1634 16.0156 22.4583C16.3346 22.7533 16.7531 22.9171 17.1875 22.9171C17.6219 22.9171 18.0404 22.7533 18.3594 22.4583L18.8625 21.9979C19.0446 21.8297 19.2834 21.7362 19.5312 21.7362C19.7791 21.7362 20.0179 21.8297 20.2 21.9979C20.849 22.5917 21.875 22.1167 21.875 21.2229V6.63541C21.875 5.3927 21.875 4.77083 21.7104 4.27083C21.5606 3.80668 21.3059 3.38325 20.9662 3.03335C20.6264 2.68345 20.2106 2.41648 19.751 2.25312C19.2635 2.08333 18.6604 2.08333 17.4531 2.08333Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89575 10.8333L11.3843 12.5L15.1041 8.33333",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 16.1458H17.1875",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQcTraywhiteIcon);
export default __webpack_public_path__ + "static/media/QC Tray whiteIcon.cac08093757e861764cea4fff35708c9.svg";
export { ForwardRef as ReactComponent };